import { render, staticRenderFns } from "./VersandaufteilungIndicator.vue?vue&type=template&id=589e6f3e&scoped=true&"
import script from "./VersandaufteilungIndicator.vue?vue&type=script&lang=js&"
export * from "./VersandaufteilungIndicator.vue?vue&type=script&lang=js&"
import style0 from "./VersandaufteilungIndicator.vue?vue&type=style&index=0&id=589e6f3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e6f3e",
  null
  
)

export default component.exports